import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface AssessmentReportButtonProps {
  id: number;
}

function AssessmentReportButton({ id }: AssessmentReportButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      onClick={() => {
        window.open(`/app/assessment-results/${id}?isFirstTime=true`, "_blank");
      }}
    >
      {t("evaluation-report")}
    </Button>
  );
}

export default AssessmentReportButton;
